import React, { ReactElement } from 'react';
import Image from 'next/image';
import classNames from 'classnames/bind';
import styles from 'sections/Home/components/SectionFeatures/SectionFeatures.module.scss';

const cn = classNames.bind(styles);

const SectionFeatures = (): ReactElement => {

  return (
    <section className={cn('features')}>
      <div className={cn('container')}>
        <div className={cn('features__list')}>

          <div className={cn('features__item')}>
            <div className={cn('features__item-icon-box')}>
              <Image
                width={15}
                height={15}
                src="/images/pages/Home/icon-star.svg"
                alt="your-business"
              />
            </div>
            <p className={cn('features__item-description')}>
              Associate your business with a leading enabler of freight forwarding logistics and trade
            </p>
          </div>

          <div className={cn('features__item')}>
            <div className={cn('features__item-icon-box')}>
              <Image
                width={16}
                height={16}
                src="/images/pages/Home/icon-tools.svg"
                alt="your-business"
              />
            </div>
            <p className={cn('features__item-description')}>Web-based tools for freight forwarders</p>
          </div>

          <div className={cn('features__item')}>
            <div className={cn('features__item-icon-box')}>
              <Image
                width={16}
                height={16}
                src="/images/pages/Home/icon-key.svg"
                alt="your-business"
              />
            </div>
            <p className={cn('features__item-description')}>Access to other DP World products</p>
          </div>

          <div className={cn('features__item')}>
            <div className={cn('features__item-icon-box')}>
              <Image
                width={18}
                height={16}
                src="/images/pages/Home/icon-toolbox.svg"
                alt="your-business"
              />
            </div>
            <p className={cn('features__item-description')}>
              Incremental business opportunities through our freight network
            </p>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default SectionFeatures;